module.exports = __webpack_public_path__ + "static/media/DSC_4149.15144a10.jpg";